/* eslint no-inline-comments: 0 */

const Lists = () => import( /* webpackChunkName: "group-automations" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-automations" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-automations" */ `./edit.vue` );
const Settings = () => import( /* webpackChunkName: "group-automations" */ `./settings.vue` );

export default {
	path: `automations`,
	children: [
		{
			path: ``,
			name: `list-automations`,
			component: Lists,
			meta: {
				title: `Automations`
			}
		},
		{
			path: `settings`,
			name: `automation-settings`,
			component: Settings,
			meta: {
				title: `Automation Settings`
			}
		},
		{
			path: `new`,
			name: `add-automation`,
			component: Add,
			meta: {
				title: `Add Automation`
			}
		},
		{
			path: `:uuid`,
			name: `edit-automation`,
			component: Edit,
			meta: {
				title: `Edit Automation`
			}
		}
	]
};
